import { render, staticRenderFns } from "./nav-options.vue?vue&type=template&id=0971a3eb&scoped=true&"
import script from "./nav-options.vue?vue&type=script&lang=js&"
export * from "./nav-options.vue?vue&type=script&lang=js&"
import style0 from "./nav-options.vue?vue&type=style&index=0&id=0971a3eb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971a3eb",
  null
  
)

export default component.exports